import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  OnboardingContextActionType,
  useOnboardingContext,
  useOnboardingDispatch
} from '@/contexts/onboardingContext';
import useMixpanel from '@/hooks/useTracking/useMixpanel';

import { RedirectingStepProps } from './types';

const RedirectingStep = (props: RedirectingStepProps) => {
  const dispatch = useOnboardingDispatch();
  const onboardingContext = useOnboardingContext();
  const navigate = useNavigate();
  const mixpanel = useMixpanel();

  useEffect(() => {
    const stepsSkipped = onboardingContext.stepsSequence.slice(
      onboardingContext.stepsSequence.indexOf(props.nodeType),
      onboardingContext.stepsSequence.indexOf(props.redirectToNodeType)
    );

    for (const step of stepsSkipped) {
      mixpanel.trackOnboardingResolvedStep(step, onboardingContext.version, 'bypassed');
    }

    dispatch({
      type: OnboardingContextActionType.GO_TO_STEP,
      payload: {
        goToNode: props.redirectToNodeType,
        fromStep: props.uid
      }
    });
    const nextStepIndex = onboardingContext.stepsSequence.indexOf(props.redirectToNodeType);
    navigate(`/onboarding/${onboardingContext.version}/${nextStepIndex + 1}`);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <></>;
};

export default RedirectingStep;
